import {useTranslation} from "react-i18next";
import {PageTemplate} from "../../../shared/layout/PageTemplate";
import {FunctionsList} from "./components/FunctionsList";

export const Functions = () => {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('side_bar.crud')}`} title={`${t('side_bar.functions')}`}
                         content={<FunctionsList/>}/>
}